<template>
  <x-page
    :loading="loading"
    :classical="true"
    :title="topicData.commodityGroupTitle"
  >
    <!-- 头图 -->
    <x-icon :src="topicData.commodityGroupBackgroundPic" :class="_.headImage" />

    <!-- 商品列表 -->
    <div :class="_.list">
      <x-goods-waterfall
        :load="handleLoadData"
        :one="true"
        :has-serial-no="true"
        :track="{
          name: '榜单商品',
          id: '57c696b0-1929-4c60-84ba-5f29688bb94b',
        }"
      />
    </div>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import {
    apiCommodityCommodityGroupBaseInfo,
    apiCommodityCommodityGroupCommodityList,
  } from '@/api'
  import { mapQuery, prepareData, Track } from '@/utils'

  export default Vue.extend({
    mixins: [
      mapQuery({
        id: 'id',
      }),
      Track.provideMark(function () {
        return new Promise(resolve => {
          const off = this.$watch(
            () => this.topicData,
            () => {
              if (this.topicData.id) {
                off?.()
                resolve({
                  page: '榜单页',
                  id: this.topicData.id,
                  name: this.topicData.commodityGroupTitle,
                })
              }
            },
            {
              immediate: true,
            },
          )
        })
      }),
    ],

    data: () => ({
      loading: true,
      topicData: {},
    }),

    activated() {
      this.prepareData()
    },

    methods: {
      async prepareData() {
        const { topicData } = await prepareData({
          topicData: apiCommodityCommodityGroupBaseInfo({
            id: this.id,
          }),
        })
        this.topicData = topicData
        this.loading = false
      },
      handleLoadData({ pageNumber }) {
        return apiCommodityCommodityGroupCommodityList({
          id: this.id,
          pageIndex: pageNumber,
          pageSize: 10,
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .headImage {
    width: 100%;
    height: 224px;
  }

  .list {
    margin-top: -120px;
    padding: 12px;
  }
</style>
